export default {"src":"/_next/static/media/mana3.6b68bb0b.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};